import { useMemo } from 'react'

import { useExpandedRows } from '../../../../../contexts/expandedRowsContext'
import { TableRow } from '../../../../../elements/TableRow'
import { PeriodValue } from '../../../../../types/inputTypes'
import { mapProfitAndLossBalances } from '../../../../../utils/balanceMappers'
import { buildTableData } from '../../../../../utils/buildTableData'
import { ProfitAndLossInputRowComponent } from '../../types/inputTypes'
import { BalanceCells } from '../BalanceCells'

interface ProfitAndLossTableBodyProps {
  reportData: ProfitAndLossInputRowComponent[]
  periods: PeriodValue[]
}

export const ProfitAndLossTableBody = ({ reportData, periods }: ProfitAndLossTableBodyProps) => {
  const { expandedRows } = useExpandedRows()

  const tableData = useMemo(
    () => buildTableData(reportData, expandedRows, periods, mapProfitAndLossBalances),
    [expandedRows, reportData, periods],
  )

  return (
    <tbody>
      {tableData.map((row) => (
        <TableRow row={row} key={row.id}>
          <BalanceCells row={row} periods={periods} />
        </TableRow>
      ))}
    </tbody>
  )
}
